import { PageTitle } from '@/components/seo/page-title';
import { AdminInvitesScreen } from '@/features/admin/screens/admin-invites-screen';

export default function InvitesPage() {
  return (
    <>
      <PageTitle title="Invite Codes" />
      <AdminInvitesScreen />
    </>
  );
}
